import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import {
  DropdownIndicator,
  formatGroupLabel,
  getParsedCrudData,
  IndicatorSeparator
} from '@nile/components';
import { AccountClient, GET_ALL_TECH_GROUP } from '@nile/graphql';
import Select from 'react-select';
import { isArray } from 'lodash';

function TechGroupShareFilter({
  data,
  updateData,
  mappingKey,
  disabled = false,
  originalData
}) {
  const {
    loading: techGrpLoading,
    data: techGroups
  } = useQuery(GET_ALL_TECH_GROUP, { client: AccountClient, skip: disabled });

  const [selectedTechGroup, setSelectedTechGroup] = React.useState(null);
  const allGroups =
    techGroups?.getTechnicianGroups?.map((el) => ({
      ...el,
      label: el.name,
      value: el.groupId
    })) || [];

  const associateTechGroups = (itms) => {
    const items = itms || [];
    setSelectedTechGroup(items);
    const {
      addedItems: addTechGroup,
      deletedItems: removeTechGroup
    } = getParsedCrudData(
      (isArray(originalData) ? originalData?.[0] : originalData)?.groups || [],
      items,
      'groupId'
    );
    const dta = {
      addedGroupIds: addTechGroup?.map((el) => el.groupId),
      deletedGroupIds: removeTechGroup?.map((el) => el.groupId),
      userSharedType: 'AllUsers',
      groupSharedType: 'Group',
      sharedType: 'SPECIFIC',
      users: null,
      groups: items
    };
    updateData(dta, mappingKey, true);
  };

  useEffect(() => {
    if (disabled) {
      setSelectedTechGroup([]);
    } else {
      setSelectedTechGroup(
        (isArray(data) ? data?.[0] : data)?.groups?.map((el) => ({
          ...el,
          label: el.name,
          value: el.groupId
        })) || []
      );
    }
  }, [data, disabled]);

  return (
    <Select
      className="wm-500 mr8"
      onChange={associateTechGroups}
      classNamePrefix="value_selector"
      formatGroupLabel={formatGroupLabel}
      components={{ IndicatorSeparator, DropdownIndicator }}
      options={allGroups}
      value={selectedTechGroup}
      isLoading={techGrpLoading}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      onClearButtonClick={() => associateTechGroups([])}
      closeMenuOnScroll={(e) => {
        return (
          e.target &&
          e.target.classList &&
          !(e.target.classList.value.indexOf('menu-list') > -1)
        );
      }}
      name="valueselector"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 })
      }}
      isDisabled={disabled}
      isMulti
    />
  );
}

export default TechGroupShareFilter;
